export const MODE_LEGACY = "legacy";
export const MODE_SHARED = "shared";

export const AUTH_DEFAULT_SIGN_IN_URL: string =
  "https://oauth.musixmatch.com/credential/signin";

export const AUTH_ACCOUNT_MANAGE_PATH = "/";
export const AUTH_ACCOUNT_SUBSCRIPTIONS_PATH = "/subscriptions";
export const AUTH_CONTRIBUTION_PREFERENCES_PATH = "/contribution-preferences";
